{
  "graphWindows": {
    "closeAll": "Close all windows"
  },
  "advancedTQLFilter": {
    "title": "Advanced TQL filter"
  },
  "matcherForm": {
    "literal": "Literal",
    "fromList": "From list",
    "operator": "Operator",
    "value": "Value",
    "addGroup": "Add group",
    "addCondition": "Add condition",
    "placeholders": {
      "value": "Value",
      "selectValue": "Select value",
      "selectValues": "Select value",
      "ip": "IP address",
      "min": "Min",
      "max": "Max"
    }
  },
  "matcherTargets": {
    "attribute": {
      "label": "Attribute",
      "errorMessage": "Missing attribute",
      "userAttributes": "User attributes"
    },
    "ciStatus": {
      "label": "CI Status"
    },
    "hiStatus": {
      "label": "HI Status"
    },
    "user": {
      "login": "Login"
    }
  },
  "conditions": {
    "and": "And",
    "or": "Or"
  },
  "tqlNode": "TQL Node",
  "nodePanel": {
    "title": "CI",
    "connected": "Connected",
    "showAll": "Show all",
    "hideAll": "Hide all",
    "type": "Type",
    "hi": "Health indicators",
    "name": "Name",
    "status": "status",
    "edit": "Edit",
    "editVariables": "Change variables",
    "delete": "Delete",
    "script": "Script",
    "action": "Action",
    "runScript": "Run script",
    "runAction": "Run action",
    "enrichment": "Perform enrichment",
    "enrichment-settings": {
      "title": "Enrichment settings",
      "enrichAttributes": "Enrich attributes",
      "enrichLinks": "Enrich links"
    },
    "showTargetAttributes": "Show target attributes",
    "targetAttributes": "Target attributes",
    "parameters": "Parameters",
    "attributes": "Attributes",
    "selectedCis": "Selected CIs",
    "currentValue": "Current value",
    "bulkLinks": {
      "title": "Link to one CI",
      "target": "Target CI",
      "selectAllAvailable": "Select all available",
      "sourceType": "CI type: {{type}}",
      "loading": "Checking links by CI type...",
      "notAllowedByTypes": "Link is not available for this CI type pair",
      "alreadyLinked": "All available link types already exist",
      "linkType": "Link type",
      "statusAllowed": "Available",
      "statusNotAllowed": "Blocked",
      "statusExisting": "Exists",
      "statusChecking": "Checking",
      "create": "Create links",
      "success": "Created links: {{count}}",
      "error": "Failed to create links"
    }
  },
  "variablesDialog": {
    "title": "Script variables",
    "empty": "No variables",
    "runScript": "Run"
  },
  "editVariablesDialog": {
    "title": "Variable editor",
    "empty": "No variables"
  },
  "layout": {
    "import": "Import",
    "export": "Export",
    "refresh": "Refresh",
    "refreshInterval": "Auto refresh",
    "graph": "Graph",
    "graphViews": "Graph views",
    "map": "Map",
    "table": "Table",
    "monitoring": "Monitoring",
    "activeHIs": "Active HIs",
    "ciHealth": "CI health",
    "search": "Search",
    "savedSearch": "Saved searches",
    "reloadData": "Reload data",
    "savedSearchEmpty": "No searches saved",
    "empty": {
      "useSearch": "Use search",
      "description": "Run a new search or open a saved query to load the graph and related views."
    },
    "showOnGraph": "Show on graph",
    "showOnMap": "Show on map",
    "viewingRelatedNodes": "Viewing related nodes",
    "display": "Display",
    "openConsole": "Open console"
  },
  "filters": {
    "clear": "Reset all",
    "connection": "Connection",
    "clone": "Clone node",
    "delete": "Delete node",
    "allLinks": "Show all links between CIs",
    "version": "Version",
    "selectCIType": "Select CI type"
  },
  "ciHealth": {
    "registry": {
      "title": "CI registry",
      "description": "{{total}} CIs from query · {{deviations}} with deviations in period"
    },
    "detail": {
      "typeAndHis": "{{type}} · {{count}} indicators",
      "outOfScope": "Out of selection",
      "linksButton": "Links",
      "links": "Links",
      "linksLoadError": "Failed to load links",
      "dashboards": "Dashboards",
      "dashboardsLoadError": "Failed to load dashboards",
      "dashboardNoFilter": "No CI filter",
      "noResources": "Nothing configured"
    },
    "columns": {
      "ci": "CI",
      "type": "Type",
      "current": "Current",
      "inStatus": "In status",
      "hisNotOk": "HIs not OK",
      "worst": "Worst in period",
      "timeNotOk": "Time not OK",
      "transitions": "Transitions"
    },
    "hiColumns": {
      "hi": "Health indicator",
      "type": "Type",
      "current": "Current",
      "inStatus": "In status",
      "worst": "Worst in period",
      "timeNotOk": "Time not OK",
      "transitions": "Trans.",
      "statusStrip": "Status strip",
      "templateDeleted": "Template deleted",
      "nodeId": "TQL Node ID: {{id}}"
    },
    "segmentTooltip": {
      "start": "Start",
      "end": "End",
      "ongoing": "In progress",
      "duration": "Duration"
    },
    "legend": {
      "notAttached": "Indicator was not attached to CI"
    },
    "hiStage": {
      "current": "Only this indicator",
      "depends": "With dependencies",
      "selectedInterval": "Selected interval <strong>{{start}} → {{end}}</strong>",
      "noSelectedInterval": "No interval selected",
      "ongoing": "continues",
      "viewSwitchHint": "The switch is only shown for calculated indicators with dependencies",
      "dependsHint": "Changed before the selected transition first, nearest at the top",
      "segments": {
        "status": "Status",
        "start": "Start",
        "end": "End",
        "clippedLeft": "Interval started before the selected window",
        "clippedRight": "Interval continues after the selected window",
        "duration": "Duration",
        "alerts": "Alerts",
        "reason": "Reason"
      }
    },
    "hiDepends": {
      "openCi": "Open CI: {{name}}",
      "openHi": "Open health indicator: {{name}}",
      "hi": "Indicator",
      "current": "Current",
      "toTransition": "To transition",
      "referencePoint": "Reference point",
      "simultaneous": "Simultaneous",
      "holdingSince": "In this status since {{date}}",
      "notAttachedAtMoment": "Was not attached at this moment",
      "alreadyReacted": "Parent already reacted",
      "accessDenied": "No access",
      "outOfScope": "Dependency is outside your permissions",
      "shown_one": "Showing <strong>{{count}}</strong> of <strong>{{total}}</strong> dependencies",
      "shown_other": "Showing <strong>{{count}}</strong> of <strong>{{total}}</strong> dependencies",
      "limitNote": "Simultaneous first, then nearest past, then none, then future"
    },
    "reason": {
      "title": "Reason",
      "causes": "Cause tree",
      "impact": "Impact tree",
      "builtAt": "At {{at}}",
      "truncated": "truncated",
      "accessDenied": "No access",
      "accessDeniedCi": "CI: no access",
      "accessDeniedHiType": "Health indicator type: no access",
      "noAccess": "No access",
      "causePath": "Cause branch",
      "deadEnd": "Source not traceable",
      "source": "Root source",
      "repeated": "(shown above)",
      "affected": "affected",
      "active": "active",
      "closedAt": "closed at {{at}}",
      "closeEvent": "Close event",
      "closeConfirm": "Close alert “{{name}}”?",
      "closeConsequence": "The alert will be marked as closed. Its history will be preserved.",
      "closeWarning": "Closing the alert manually does not resolve its cause. It may reappear if triggered again.",
      "closeAttribution": "Your account will be recorded as the user who closed the alert.",
      "forceCloseWarning": "This alert closes automatically. Closing it by force",
      "alertClosed": "Alert closed",
      "rootCause": "Root cause",
      "intervalAlerts": "Interval alerts",
      "selectInterval": "Select an interval to see the data",
      "otherAlerts_one": "{{count}} more alert",
      "otherAlerts_other": "{{count}} more alerts",
      "alertsLoadError": "Could not load alerts",
      "noAlerts": "No alerts",
      "analyze": "Analyze",
      "ciType": "CI type: {{label}} ({{name}})",
      "openCi": "Open CI",
      "triggeredTransition": "Triggered the transition",
      "beforeParent": "{{duration}} before parent",
      "afterTransition": "after the transition",
      "sameTimeAsParent": "at the same time as parent",
      "moreDependencies_one": "{{count}} more dependency",
      "moreDependencies_other": "{{count}} more dependencies",
      "noData": "No data",
      "loadError": "Could not load the reason tree",
      "evidence": {
        "notConfigured": "No media source is configured for this indicator",
        "showThumbnails": "Show thumbnails",
        "hideThumbnails": "Hide thumbnails",
        "tolerance": "Tolerance",
        "window": "Window",
        "transition": "Transition",
        "interval": "Interval",
        "unavailableNote": "Some objects are unavailable. The remaining evidence can still be viewed.",
        "loadMore": "Show more",
        "title": "Evidence",
        "empty": "No media was saved for this interval",
        "loadError": "Could not load evidence",
        "unavailable": "Object unavailable",
        "nearest": "At transition",
        "position": "{{index}} of {{total}}",
        "previous": "Previous evidence",
        "next": "Next evidence",
        "download": "Download file",
        "exitFullscreen": "Exit fullscreen"
      }
    },
    "search": {
      "registry": "Search by CI",
      "ci": "Search by health indicators, monitoring templates"
    }
  },
  "tqlList": {
    "columns": {
      "name": "Name",
      "label": "Display name"
    }
  },
  "filterDialog": {
    "title": "Saved search",
    "name": "Name",
    "label": "Label",
    "systemName": "System name",
    "menu": "Menu",
    "tags": "Tags",
    "cit": "CIT",
    "openModal": "Open in modal window",
    "countCi": "Count CI",
    "rollback": "Rollback",
    "clear": "Clear",
    "fitView": "Fit view",
    "noParamsMessage": "Graph executed without parameters"
  },
  "customNode": {
    "filtered": "Filtered",
    "hidden": "Hidden",
    "invalidTarget": "No available links",
    "viewCis": "View CIs",
    "edit": "Edit",
    "rename": "Rename",
    "delete": "Delete"
  },
  "nodeCisDialog": {
    "title": "Selected node CIs",
    "columns": {
      "id": "ID",
      "ciType": "CI type",
      "name": "Name"
    }
  },
  "nodeRenameDialog": {
    "nodeAliasName": "Node alias name",
    "aliasName": "Alias name"
  },
  "nodeDialog": {
    "title": "CI",
    "type": "Type",
    "composingCi": "Composing CI",
    "secretAttribute": {
      "placeholder": "Value is set",
      "description": "Leave empty to keep the current value",
      "clear": "Clear"
    },
    "fileComponent": {
      "upload": "Load file",
      "delete": "Delete file",
      "msg": {
        "saveSuccess": "File saved",
        "deleteSuccess": "File deleted"
      }
    }
  },
  "bulkNodeDialog": {
    "title": "Create CI",
    "basicParameters": "Basic parameters",
    "tableTitle": "Configuration item attributes",
    "tableDescription": "Set attribute values for the CIs being created",
    "hintTitle": "Hint",
    "hintDescription": "Add the attributes that will be used to describe your CI.",
    "attributes": "Attributes",
    "rows": "Configuration items",
    "addRow": "Add row",
    "cloneRow": "Clone",
    "addRowDisabledNoAttributes": "Select attributes to add a row",
    "addAttributesPlaceholder": "Add attributes",
    "addCIAttributesPlaceholder": "Add CI attributes",
    "required": "required",
    "noAttributes": "Select a CI type",
    "copyToAll": "Copy value to all CIs",
    "successSaveMsg": "CIs created",
    "abortConfirmTitle": "Stop creation?",
    "abortConfirmText": "The creation cycle will be stopped. Already created CIs will remain saved.",
    "columns": {
      "status": "Status"
    },
    "status": {
      "draft": "Draft",
      "processing": "Creating",
      "success": "Created",
      "error": "Error"
    }
  },
  "nodeConflictDialog": {
    "title": "CI resolve conflict details",
    "cancel": "Cancel",
    "edit": "Edit",
    "merge": "Merge",
    "currentChanges": "Current changes",
    "result": "Result",
    "attributes": "Attributes",
    "noAttributes": "No attributes",
    "deleteCiList": "CI to delete",
    "deleteLinkList": "List of links to delete",
    "createLinkList": "List of links to create"
  },
  "ciConflictDialog": {
    "title": "⚠️ Conflict detected when creating CI",
    "description": "The system detected that the CI being created duplicates existing ones. To maintain data integrity, it is proposed to merge the information. Click on a duplicate to view its attributes.",
    "finalCI": "✅ Final configuration item (Will be saved)",
    "deletedDuplicates": "🗑️ Duplicates to be deleted (Will be deleted)",
    "name": "Name",
    "type": "Type",
    "id": "ID",
    "attributes": "Attributes",
    "attribute": "Attribute",
    "value": "Value",
    "reject": "Reject",
    "confirmMerge": "Confirm merge",
    "loading": "Loading...",
    "expandDuplicates": "Expand duplicates",
    "collapseDuplicates": "Collapse duplicates",
    "ci": "CI",
    "undefinedName": "Name is not defined"
  },
  "overlayText": "Tap to edit",
  "connectionDialog": {
    "title": "Link",
    "form": {
      "type": "Type",
      "limitations": "Limitations",
      "from": "From",
      "to": "To",
      "source": "Source",
      "target": "Target",
      "direction": "Direction",
      "limitationsDirection": "Limitations direction"
    },
    "validation": {
      "from": "Only numbers",
      "to": "Only numbers and *"
    }
  },
  "nodeReferencesDialog": {
    "title": "Related nodes",
    "onGraph": "On graph",
    "willBeAdded": "Will be added",
    "outgoingLinks": "Outgoing links",
    "showExisting": "Show existing nodes and links",
    "selectedSummary": "Selected: {{nodes}} nodes · {{links}} links"
  },
  "configurationDialog": {
    "title": "Configuration",
    "reloadButton": "Restore Configuration",
    "reloadButtonWarn": "Do you really want to restore the configuration? All information in running-config will be overwritten!",
    "fetchHistory": "Fetch history",
    "history": "History",
    "revisions": "Revisions",
    "value": "Value",
    "historyLoaded": "History loaded",
    "historyDisabled": "History saving is not configured for this attribute. Only the current value is available.",
    "historyStatusUnavailable": "Could not check history saving settings. Only the current value is available.",
    "historyEmpty": "Change history for this attribute does not contain records yet.",
    "historyLoadError": "Could not load change history. Please try again later.",
    "attributeValueHistoryTitle": "Attribute value history",
    "textView": "Text",
    "formView": "Form",
    "cmEditor": "Code Mirror",
    "rjsf": "RJSF"
  },
  "mapDialog": {
    "title": "Location of the CIT",
    "locationUndefined": "Не определено"
  },
  "settingsDialog": {
    "title": "Filter",
    "conditions": {
      "or": "OR",
      "and": "AND"
    },
    "attribute": "Attribute",
    "status": "Status",
    "group": "Group",
    "login": "User's login",
    "hi-status": "HI Status",
    "form": {
      "attribute": "Attribute",
      "status": "Status CI",
      "login": "User's login",
      "hi-status": "HI Status",
      "operator": "Operator",
      "value": "Input value",
      "valueVariables": "Input from variables",
      "valueExecute": "Input value in executing",
      "includeInResult": "Add to query result",
      "invalidCondition": "Invalid condition",
      "noOperator": "Select operator",
      "deprecatedFieldValues": "Deprecated field values",
      "listItem": {
        "dialog": {
          "title": "Item list"
        }
      }
    }
  },
  "graphViews": {
    "actions": {
      "dragAndDropCompoundMode": "Group by dragging",
      "convertToCompound": "Convert to compound",
      "collapse": "Collapse",
      "expand": "Expand",
      "collapseAll": "Collapse all",
      "expandAll": "Expand all",
      "collapseRecursively": "Collapse recursively",
      "expandRecursively": "Expand recursively",
      "collapseSelected": "Collapse selected",
      "expandSelected": "Expand selected",
      "collapseSelectedRecursively": "Collapse selected recursively",
      "expandSelectedRecursively": "Expand selected recursively",
      "groupSelected": "Group selected",
      "ungroupSelected": "Ungroup selected",
      "ungroupAll": "Ungroup all",
      "group": "Group",
      "ungroup": "Ungroup",
      "viewCI": "View CI",
      "remove": "Remove",
      "removeUnavailable": "Remove unavailable elements"
    },
    "text": {
      "group": "Group",
      "compoundNode": "Compound node",
      "compoundEdge": "Compound edge",
      "nodes": "Nodes",
      "edges": "Edges",
      "unavailableNode": "Node is not present in TQL query selection",
      "unavailableEdge": "Edge is not present in TQL query selection"
    }
  },
  "graphView": {
    "panel": {
      "chrRecordButton": "Record",
      "chrRecord": "Record changes",
      "addNodeMode": "Add CIT",
      "drawLinkMode": "Link creation mode",
      "saveGraph": "Save graph as image",
      "selectActiveCis": "Select active CIs"
    },
    "filter": {
      "cits": "Filter by CIT",
      "nodes": "Filter by TQL nodes",
      "his": "Filter by HI",
      "crs": "Filter by PC",
      "graphScheme": {
        "schema": "Schema",
        "monitoring": "Monitoring"
      },
      "graphLayout": "Graph layout",
      "zoomClusters": "Zoom clusters"
    }
  },
  "tqlGraphView": {
    "title": "TQL Graph View",
    "settings": {
      "loadFailed": "Failed to apply the saved view",
      "label": "Display name",
      "name": "Name",
      "displayOrder": "Display Order",
      "savedViews": "Saved Views",
      "deletedView": "Deleted View"
    }
  },
  "tableView": {
    "settings": "Display settings",
    "settingsAttribute": {
      "display": "Attribute settings",
      "groupByCIT": "Group by CI type",
      "displayInTable": "Display in table",
      "form": {
        "attributes": "Display attributes"
      }
    },
    "render": "Table view",
    "exportType": {
      "linear": "Without group",
      "group": "Group"
    },
    "columns": {
      "name": "Name",
      "ciType": "CI type"
    },
    "report": {
      "dataNotReceived": "data not received",
      "columns": "Report columns",
      "metrics": "Metrics",
      "documents": "Documents",
      "groups": "Subrow groups",
      "addColumn": "Add column",
      "addGroup": "Add group",
      "source": "Source",
      "label": "Column name",
      "query": "Query",
      "index": "Index",
      "joinKind": {
        "field": "CI field",
        "attribute": "CI attribute",
        "none": "No join: one value for every CI",
        "key": "By join key"
      },
      "ciKey": "CI field or attribute",
      "sourceKey": "Metric label or document field",
      "aggregation": "Several values per key",
      "total": "Total on the CI row",
      "totalOff": "Off",
      "valuePath": "Path to the value in a bucket",
      "groupLabel": "Group name",
      "subrowKeys": "Subrow key labels",
      "titleKey": "Subrow title label",
      "labelHint": "Put the period and the unit into the column name",
      "queryHint": "A TQL node reference substitutes the list of report CIs",
      "joinHint": "Key parts are taken from the CI itself and from its composition ancestors",
      "aggregations": {
        "sum": "Sum",
        "avg": "Average",
        "min": "Minimum",
        "max": "Maximum",
        "count": "Count"
      },
      "columnTitle": "Report column",
      "groupTitle": "Subrow group",
      "joinKindLabel": "On the CI side",
      "group": "Subrow group",
      "noGroup": "None: a CI row column",
      "subrowKeysHint": "Metric labels or document fields that make the subrow key",
      "withoutJoin": "no join",
      "notAggregatable": "grouping is not available",
      "ciFields": "CI fields",
      "ciAttributes": "Attributes of the node CI type",
      "noJoinHint": "The value goes to every CI of the node",
      "groupDisabled": "Without a join rule there is no key for subrows",
      "joinKey": "Join key",
      "joinKeyHint": "A source value goes to the row where every part of the key matched",
      "addJoinPart": "Add a key part",
      "ownNode": "this CI",
      "ambiguousJoin": "join key is not unique",
      "joinNode": "Node"
    },
    "unsavedChanges": "There are unsaved changes",
    "saveSettings": "Save the setting"
  },
  "ciImportDialog": {
    "title": "Import",
    "importType": "Import type",
    "importCi": "CI",
    "importGraph": "Graph",
    "type": "Type",
    "file": "File",
    "downloadTemplate": "Download template",
    "chooseFile": "Choose file",
    "import": "Import",
    "conflictData": {
      "ci_name": "CI Name",
      "ci_type": "CI Type"
    },
    "message": {
      "importSuccess": "Imported"
    }
  },
  "ciExportDialog": {
    "title": "Export",
    "CSV": "CSV",
    "JSON": "JSON",
    "cis": "CIs",
    "ciType": "CI type",
    "tqlNode": "TQL node",
    "attributes": "attributes",
    "nodeAttributes": "Node attributes",
    "nodesAttributes": "Nodes attributes"
  },
  "ciImportResultDialog": {
    "title": "Import result",
    "cisTotal": "Imported CI",
    "linksTotal": "Imported links"
  },
  "inputDialog": {
    "title": "Query variables"
  },
  "actions": {
    "startRec": "Start recording",
    "stopRec": "Stop",
    "regActive": "Recording"
  },
  "hiHistoryView": {
    "prometheus": "Prometheus",
    "vm": "Rules processing agent",
    "affects": "Affects on",
    "depends": "Depends of",
    "dialog": {
      "hi": "Health indicator",
      "title": "CI health in period",
      "ci": "CI",
      "finishedAt": "Finished",
      "hit": "Type",
      "duration": "Duration",
      "severity": "Severity",
      "startedAt": "Started at",
      "labels": "Labels",
      "annotations": "Annotations"
    }
  }
}